import React from "react";
import "./OrchesHero.css";
import image from "../orchesassets/heroimage.png";

export default function OrchesHero() {
  return (
    <div id="orches-hero" className="outsourcemainclass">
      <h2 className="heading">DevOps Monitoring & Observability Services</h2>
      <p className="subheading">
   Gain complete visibility into your applications and infrastructure with BastionEx’s DevOps Monitoring & Observability services. We help organizations proactively monitor systems, analyze performance, and gain actionable insights to ensure reliability, availability, and optimal user experiences across environments.
      </p>
      <button>Let's Discuss Your Project</button>
      <div className="image">
        <img src={image} alt="error" />
      </div>
    </div>
  );
}
